// @file Data Access Layer helpers

import { browsingContextUid } from '@@/bits/global'
import { currentHostname } from '@@/bits/location'
import { DataAccessLayer } from '@padlet/dalfe'

const dal = new DataAccessLayer({
  clientUid: browsingContextUid,
  mozartHost: currentHostname(),
  mozartToken: 'TODO: Unused',
})

export default dal
